import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-salvia/40 py-10" data-id="element-87" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-6 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-88" data-mp="3gfiu2hdxs9dl">
        <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-bosque" data-id="element-89" data-mp="32pp764lzrz6i">
          Mindfulness para Hockey
        </p>
        <p className="text-xs text-tinta/45" data-id="element-90" data-mp="3ufa6wespvjq0">
          © {new Date().getFullYear()} Mindfulness para Hockey. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}